module.exports = __webpack_public_path__ + "static/media/H4_boom leeg apart.5eda3219.png";